import { useEffect, useState } from 'react'

export default function GeneratingReport({
  isCompleted,
  isSuccess,
}: {
  isCompleted?: boolean
  isSuccess: boolean
}) {
  const PROGRESS_UPDATE_INTERVAL = 300
  const PROGRESS_INCREMENT = 1

  const [progress, setProgress] = useState(0)
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    if (isCompleted) {
      setProgress(100)
      const timeout = setTimeout(() => {
        setIsVisible(false)
      }, 500)
      return () => clearTimeout(timeout)
    }

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval)
          return 100
        }
        return prev + PROGRESS_INCREMENT
      })
    }, PROGRESS_UPDATE_INTERVAL)

    return () => clearInterval(interval)
  }, [isCompleted])

  if (!isVisible) {
    return (
      <div className="flex flex-col items-center justify-center  h-full w-full">
        <div className="px-4 text-center">
          {isSuccess
            ? 'Report generated successful. Downloading your report...'
            : 'Failed to generate the report. Please try again.'}
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <p> Report generation in progress. Please wait...</p>
      <div className="w-64 bg-gray-200 rounded-full h-2.5 mt-4">
        <div
          className="bg-primary h-2.5 rounded-full transition-all duration-1000"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <p className="mt-2 text-sm text-gray-600">{progress}%</p>
    </div>
  )
}
